import { addParticipant } from "api/participant_add";
import { AxiosError } from "axios";
import { FieldValues, UseFormSetError, UseFormWatch } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import onErrorMutation from "utils/onErrorMutation";
import onSuccessMutation from "utils/onSuccessMutation";
import { notVisibleFieldsParticipant } from "../constants";

const useAddParticipant = (
  participantLastSearch: string,
  watch: UseFormWatch<FieldValues>,
  setError: UseFormSetError<FieldValues>
) => {
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: addParticipant,
    onSuccess: (p) =>
      onSuccessMutation(
        p,
        `/participant/${participantLastSearch}`,
        navigate,
        false,
        `Контрагент "${watch("name")}" добавлен`
      ),
    onError: (err) => onErrorMutation(err as AxiosError, setError, notVisibleFieldsParticipant)
  });

  return mutate;
};

export default useAddParticipant;
